interface IArrivalIconProps {
  mainColor?: string;
  secondaryColor?: string;
  className?: string | undefined;
  onClick?: () => void;
}

const ArrivalIcon: React.FC<IArrivalIconProps> = ({
  mainColor,
  secondaryColor,
  className,
  onClick,
}) => (
  <svg
    width="61"
    height="62"
    viewBox="0 0 61 62"
    xmlns="http://www.w3.org/2000/svg"
    className={className}>
    <g fill="none" fillRule="evenodd">
      <path
        style={{ fill: mainColor || 'var(--tt-dark-purple)' }}
        d="M30.66 13.385v20.08H15.6l-7.53-5.02H3.05l10.04 12.55h45.18v-5.02l-7.53-2.51H40.7l-5.02-20.08z"
      />
      <path
        style={{ fill: secondaryColor || 'var(--tt-yellow)' }}
        d="M3.05 48.525h55.22v-2.51H3.05z"
      />
    </g>
  </svg>
);

export default ArrivalIcon;
